import { Box, Container } from '@mui/material'
import Progress from '../Progress'
import { ThankyouForRequest } from '../ThankyouForRequest'
import { withAuthenticationRequired, useAuth0 } from '@auth0/auth0-react'
import { Loading } from '../Loading'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { isNil } from 'lodash/fp'

export const EntryBase = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const {
    isAuthenticated,
    isLoading,
    getAccessTokenSilently,
    loginWithRedirect
  } = useAuth0()
  useEffect(() => {
    const checkAuth = async () => {
      if (!isAuthenticated && !isLoading) {
        try {
          await getAccessTokenSilently()
        } catch (error) {
          const query = new URLSearchParams(location.search)
          const queryError = query.get('error_description')
          if (!isNil(queryError)) {
            const errorObject = JSON.parse(queryError)
            if (
              !isNil(errorObject.error_code) &&
              errorObject.error_code === '01'
            ) {
              navigate('/emailUnverified')
            } else {
              navigate('/serverError')
            }
            return
          }
          loginWithRedirect()
        }
      }
    }
    checkAuth()
  }, [isAuthenticated, isLoading, getAccessTokenSilently, loginWithRedirect])

  const contentNameArray = [
    'お申込みフォーム',
    'クレジットカード登録',
    'お申込み内容のご確認'
  ]
  const buttonNames = {
    next: '次へ',
    back: '戻る',
    submit: 'お申し込み',
    correct: '修正'
  }
  return (
    <Box>
      <Container maxWidth="xl">
        <Progress
          contentNameArray={contentNameArray}
          buttonNames={buttonNames}
          lastContent={<ThankyouForRequest />}
        />
      </Container>
    </Box>
  )
}

export default withAuthenticationRequired(EntryBase, {
  onRedirecting: () => <Loading />
})
